import { render, staticRenderFns, recyclableRender, components } from "./uni-popup-message.vue?vue&type=template&id=38167fe2&"
var renderjs
import script from "./uni-popup-message.vue?vue&type=script&lang=js&"
export * from "./uni-popup-message.vue?vue&type=script&lang=js&"
import style0 from "./uni-popup-message.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!C:\\Users\\dell\\Downloads\\HBuilderX.3.2.16.20211122.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uni-popup/components/uni-popup-message/uni-popup-message.vue"
export default component.exports